import {ArchivableItemREST, ArchiveRecord} from './ArchiveConstants';

/**
 * @returns minimally cloned copy of `itemsById` with the items specified in `updatedItemIds` updated with
 * their corresponding archive records from `archiveRecordGetter`
 */
function updateItemArchiveRecords<ItemType extends ArchivableItemREST>(
  itemsById: {[id: string]: ItemType},
  updatedItemIds: Array<string>,
  newArchiveRecordGetter: (id: string) => ArchiveRecord | null
): {[id: string]: ItemType} {
  const updatedItemsById = {...itemsById};
  updatedItemIds.forEach((id) => {
    updatedItemsById[id] = {...updatedItemsById[id], archiveRecord: newArchiveRecordGetter(id)};
  });
  return updatedItemsById;
}

export function updateItemsOnArchive<ItemType extends ArchivableItemREST>(
  itemsById: {[id: string]: ItemType},
  archivedItemIds: Array<string>,
  archiveRecordsByItemId: {[id: string]: ArchiveRecord}
): {[id: string]: ItemType} {
  return updateItemArchiveRecords(itemsById, archivedItemIds, (id) => archiveRecordsByItemId[id]);
}

export function updateItemsOnUnarchive<ItemType extends ArchivableItemREST>(
  itemsById: {[id: string]: ItemType},
  archivedItemIds: Array<string>
): {[id: string]: ItemType} {
  return updateItemArchiveRecords(itemsById, archivedItemIds, () => null);
}
